import { render } from "./receiptUser.vue?vue&type=template&id=c4504110&scoped=true"
import script from "./receiptUser.vue?vue&type=script&lang=js"
export * from "./receiptUser.vue?vue&type=script&lang=js"

import "./receiptUser.vue?vue&type=style&index=0&id=c4504110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4504110"]])

export default __exports__